<div class="supplementary-equipment">
  <div class="form-box">
    <sc-flex [vertical]="true" [stretchContent]="true">
      <h5>{{'Available Equipment' | translate:['tmc.truck-details-dialog.supplementaryequipment.available.title',
        translationService.language]}}</h5>
      <div class="form-checkbox" *ngIf="availableEquipment.length === 0">
        {{'No Equipment available' | translate:['tmc.truck-details-dialog.supplementaryequipment.noEquipmentAvailable',
        translationService.language]}}
      </div>
      <div class="form-checkbox" *ngFor="let se of availableEquipment">
        <div class="checkbox-label">
          <mat-checkbox [(ngModel)]="se.selected" name="{{getSeCbxName(se)}}" [ngModelOptions]="{standalone: false}">
            {{se.dictionaryKey | translate:[se.dictionaryKey, translationService.language]}}</mat-checkbox>
        </div>
        <mat-form-field class="checkbox-value" class="checkbox-value" *ngIf="isStringParameter(se)">
          <input matInput [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: false}" required
            [disabled]="!se.selected" name="{{getSeValueName(se)}}"
            placeholder="{{se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]}}">
        </mat-form-field>
        <mat-form-field class="checkbox-value" class="checkbox-value" *ngIf="isNumberParameter(se)">
          <input matInput [type]="'number'" [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: false}"
            required [disabled]="!se.selected" name="{{getSeValueName(se)}}"
            placeholder="{{se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]}}">
        </mat-form-field>
      </div>
      <h5>{{'Assigned Equipment' | translate:['tmc.truck-details-dialog.supplementaryequipment.assigned.title',
        translationService.language]}}</h5>
      <div class="form-checkbox" *ngIf="truck.equipment.length === 0">
        {{'No Equipment assigned' | translate:['tmc.truck-details-dialog.supplementaryequipment.noEquipmentAssigned',
        translationService.language]}}
      </div>
      <div class="form-checkbox" *ngFor="let se of truck.equipment">
        <div class="checkbox-label">
          <mat-checkbox [(ngModel)]="se.selected" name="{{getSeCbxName(se)}}" [ngModelOptions]="{standalone: false}">
            {{se.dictionaryKey | translate:[se.dictionaryKey, translationService.language]}}</mat-checkbox>
        </div>
        <mat-form-field class="checkbox-value" class="checkbox-value" *ngIf="isStringParameter(se)">
          <input matInput [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: false}" required
            [disabled]="!se.selected" name="{{getSeValueName(se)}}"
            placeholder="{{se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]}}">
        </mat-form-field>
        <mat-form-field class="checkbox-value" class="checkbox-value" *ngIf="isNumberParameter(se)">
          <input matInput [type]="'number'" [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: false}"
            required [readonly]="true" name="{{getSeValueName(se)}}"
            placeholder="{{se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]}}">
        </mat-form-field>
      </div>
    </sc-flex>
  </div>
</div>